/**
 * @description Checks whether or not the value passed in is an instance of Error
 *
 * @param {unknown} valueToCheck The value to check
 * @returns {boolean} Type casting if the value is an error
 */
export var isError = function (valueToCheck) { return valueToCheck instanceof Error; };
//# sourceMappingURL=isError.js.map